import {Component, NgZone, AfterViewInit} from "@angular/core";
import {ViewController, Events} from "ionic-angular";
import {environment} from "../../config/environment";

declare var google: any;
declare var window: any;

@Component({
  templateUrl: 'places-search-modal.component.html',
})
export class PlacesSearchModal implements AfterViewInit{

  autocompleteService: any;
  placesService: any;
  places: any[];

  constructor(private viewCtrl: ViewController, private zone: NgZone, private events: Events) {
  }

  ngAfterViewInit(): any {
    this.loadGoogleApisAndInit();
  }

  private initGoogleAutocomplete() {
    this.placesService = new google.maps.places.PlacesService(
      window.document.getElementById('googleAttributions')
    );
    this.autocompleteService = new google.maps.places.AutocompleteService();
  }

  private loadGoogleApisAndInit() {
    if (document.getElementById('googleApis')) {
      return this.initGoogleAutocomplete();
    }

    let script = document.createElement("script");
    script.id = 'googleApis';
    script.type = 'application/javascript';
    script.onload = () => this.initGoogleAutocomplete();
    // <script src="https://maps.googleapis.com/maps/api/js?key={{ environment.google.key }}&libraries=places"></script>
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.google.key}&libraries=places`;
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  selectPlace(place){
    this.placesService.getDetails({
      placeId: place.place_id
    }, (detailedPlace: any) => {
      this.events.publish('place:selected', detailedPlace);
      this.dismiss();
    });
  }

  getPlaces(ev: any){
    let val = ev.target.value;
    if(!val || val.trim() === ''){
      return;
    }

    this.autocompleteService.getPlacePredictions({
      input: val,
      types: []
    }, (places, status) => {
      if (status != google.maps.places.PlacesServiceStatus.OK) {
        return;
      }
      this.zone.run(() => this.places = places);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/places-search-modal/places-search-modal.component.ts